import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ValidationError } from './ValidationError';

const GENERIC_FALLBACK = 'Something went wrong. Please try again.';

export function applyValidationErrorToForm<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fallbackMessage: string = GENERIC_FALLBACK
): void {
  if (error instanceof ValidationError) {
    Object.entries(error.fieldErrors).forEach(([field, messages]) => {
      setError(field as Path<T>, { message: (messages as string[]).join(', ') });
    });
    if (error.formErrors.length > 0) {
      setError('root', { message: error.formErrors.join(', ') });
    }
    return;
  }

  const message = error instanceof Error && error.message ? error.message : fallbackMessage;
  setError('root', { message });
}
